import { Check } from "@mui/icons-material";
import { useEffect } from "react";
import TableLabel from "./TableLabel";

const FormModel = ({ onClose, children }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" || e.keyCode === 27) {
        if (typeof onClose === "function") onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);
  return (
    <div className="absolute inset-0 bg-black/10 backdrop-blur-sm rounded-[10px] flex flex-col justify-center items-center z-50">
      <div className="w-full lg:w-[90%] overflow-y-auto">{children}</div>
      <div className="absolute bottom-0 right-0 w-[100px] px-6 p-2 flex mb-2 justify-end items-center gap-2 z-10">
        <button
          onClick={() => onClose()}
          className={`text-[14px] font-semibold p-1 mb-4 mr-4 rounded-full bg-[#14CF92] text-white hover:bg-success/80 `}
        >
          <Check />
        </button>
      </div>
    </div>
  );
};

export default FormModel;
